import "./baseConfig/font.css.ts.vanilla.mjs";
import "./tag.css.ts.vanilla.mjs";
var g = "p273__tag-db7d_fc924d89b__1ng215g0";
export {
  g as tagStyle
};
//# sourceMappingURL=tag.mjs.map
